import PropTypes from 'prop-types'
import { useState, useEffect, useRef, useCallback } from 'react'
import Modal from 'react-bootstrap/Modal'
import Spinner from 'react-bootstrap/Spinner'
import { useNavigate } from 'react-router-dom'
import { withValidador } from '../../hoc/withValidador'
import Metadatos from '../../publicaciones/Metadatos'
import AgregarFotos from '../../publicar/AgregarFotos'
import DescripcionProducto from '../../publicar/DescripcionProducto'
import FechaPublicacion from '../../publicar/FechaPublicacion'
import IndicarEtiquetas from '../../publicar/IndicarEtiquetas'
import ListaDeVentas from '../../publicar/ListaDeVentas'
import Ofertas from '../../publicar/Ofertas'
import VentasEspeciales from '../../publicar/VentasEspeciales'
import { actualizar } from '../../servicios/publicacionesService'
import * as publicacionService from '../../servicios/publicacionesService'
import LinkButton from '../../ui/LinkButton'
import Borde from './borde/Borde'
import CambioPrecio from './CambioPrecio'
import { getEsquema } from './esquema'
import Estado from './Estado'
import Exposicion from './Exposicion'

const MILISEGUNDOS_A_SEGUNDOS = 1000
const SEGUNDOS_A_MINUTOS = 60
const SUMA_MINUTOS = 5

const DetalleCabecera = (props) => {
  const refPaso2 = useRef(null)
  const navigate = useNavigate()

  const [errores, setErrores] = useState({})
  const [grabando, setGrabando] = useState(false)
  const [publicacion, setPublicacion] = useState({})
  const [idPublicacionEstado, setIdPublicacionEstado] = useState(
    props.publicacion.idPublicacionEstado
  )
  const [showModal, setShowModal] = useState(false)
  const [showModalMessage, setShowModalMessage] = useState('')
  const [metadatos, setMetaDatos] = useState([])

  const idVendedor = parseInt(localStorage.getItem('idUsuario'))
  const timeout =
    process.env.VITE_EXPIRATION_TIME / SEGUNDOS_A_MINUTOS / MILISEGUNDOS_A_SEGUNDOS +
    SUMA_MINUTOS

  const handleClose = useCallback(() => {
    setShowModal(false)
    setPublicacion(props.publicacion)
  }, [props.publicacion])

  useEffect(() => {
    if (Object.keys(props.publicacion).length > 0) {
      setPublicacion(props.publicacion)
    }
  }, [props.publicacion])

  const pasoValido = useCallback(
    (name) => {
      const erroresValidacion = props.Validador.validarDato(
        getEsquema(),
        publicacion,
        name
      )
      setErrores(erroresValidacion || {})
      if (erroresValidacion) {
        return false
      } else {
        return true
      }
    },
    [props.Validador, publicacion]
  )

  const handleChangeState = (name, value, callBack) => {
    setPublicacion((prevState) => ({
      ...prevState,
      [name]: value
    }))
    if (callBack) {
      callBack()
    }
  }

  const obtenerValor = useCallback((value, valueCalculado, checked, type, tipoDato) => {
    let val
    switch (tipoDato) {
      case 'bool':
        val = value === 'true'
        break
      case 'num':
        val = Number(value)
        break
      case 'calc':
        val = valueCalculado
        break
      default:
        val = type === 'checkbox' || type === 'radio' ? checked : value
        break
    }
    return val
  }, [])

  const handleChange = useCallback(
    ({ currentTarget: input }, tipoDato = '', valueCalculado = null) => {
      const { name, value, checked, type } = input
      pasoValido(input.name)
      handleChangeState(
        name,
        obtenerValor(value, valueCalculado, checked, type, tipoDato),
        () => {
          pasoValido(name)
        }
      )
      if (name === 'idPublicacionEstado') {
        if (value === '2') {
          setShowModalMessage(
            `Publicaremos tu producto en la tienda virtual. Ten en cuenta que este proceso puede demorar como mínimo ${
              timeout
            } minutos, para que esté disponible a otros compradores.`
          )
          setIdPublicacionEstado(parseInt(value))
          setShowModal(true)
        }

        if (value === '3') {
          setShowModalMessage(
            `Estás a punto de pausar tu publicación. Si lo haces, otros compradores no podrán comprar esta publicación. Si más tarde deseas republicarla, ten en cuenta que el proceso puede demorar como mínimo ${
              timeout
            } minutos, para que esté disponible a otros compradores.`
          )
          setIdPublicacionEstado(parseInt(value))
          setShowModal(true)
        }
      }
    },
    [pasoValido, handleChangeState, obtenerValor, timeout]
  )

  const validarForm = useCallback(async () => {
    handleClose()
    if (!pasoValido('titulo')) {
      return
    }
    if (!pasoValido('descripcion')) {
      return
    }
    if (!pasoValido('hasta')) {
      return
    }
    if (!pasoValido('etiquetas')) {
      return
    }
    if (!pasoValido('precioUnitario')) {
      if (refPaso2.current) {
        refPaso2.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })
      }
      return
    }
    if (!pasoValido('mediosPagos')) {
      return
    }
    if (!pasoValido('mediosEnvios')) {
      return
    }
    setGrabando(true)

    await actualizar(publicacion).then(() => {
      setGrabando(false)
    })
    cancelarForm()
  }, [pasoValido, publicacion, props, handleClose])

  const cancelarForm = () => {
    navigate('/Publicaciones/Administrar')
  }

  const obtenerMetaDatos = useCallback(async () => {
    if (publicacion.idPublicacion > 0) {
      const { data } = await publicacionService.buscarMetadato(publicacion.idPublicacion)
      setMetaDatos(data)
    }
  }, [publicacion.idPublicacion])

  useEffect(() => {
    obtenerMetaDatos()
  }, [obtenerMetaDatos])

  const tieneMetadatos = metadatos.some((m) => m.valor !== '')

  return (
    <>
      <form className="container-general" onSubmit={(e) => e.preventDefault()}>
        <div className="row">
          <div className="col-12">
            <p className="titulo-detalle">Publicaciones Seleccionadas</p>
            <div className="row">
              <div className="col-4">{publicacion.titulo}</div>
              <div className="col">
                {publicacion.monedaSimbolo}
                {publicacion.precioUnitario}
              </div>
              <div className="col">
                Vendidos:
                {publicacion.totalItemsPedidos}
              </div>
              <div className="col">{publicacion.publicacionEstado}</div>
              <div className="col">Exposición {publicacion.publicacionExposicion}</div>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-4 borde-formulario">
              <Borde titulo="Exposición">
                <Exposicion
                  onChangeState={handleChangeState}
                  idExposicionAnterior={props.publicacion.idPublicacionExposicion}
                  idExposicionNueva={publicacion.idPublicacionExposicion}
                />
              </Borde>
            </div>
            <div className="col-sm-3 borde-formulario">
              <Borde titulo="Vigencia" error={errores.hasta}>
                <FechaPublicacion
                  vieneDeAdministrar={true}
                  onChange={handleChange}
                  valueDesde={publicacion.desde}
                  valueHasta={publicacion.hasta}
                  disabledDesde
                />
              </Borde>
            </div>
            <div className="col-sm-4 borde-formulario">
              <Borde titulo="Etiquetas" error={errores.etiquetas}>
                <IndicarEtiquetas
                  vieneDeAdministrar={true}
                  onChangeState={handleChangeState}
                  value={publicacion.etiquetas}
                />
              </Borde>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6 borde-formulario">
              <Borde titulo="Incluir en Lista de Ventas">
                <ListaDeVentas
                  vieneDeAdministrar={true}
                  idVendedor={idVendedor}
                  onChange={handleChange}
                  onChangeState={handleChangeState}
                  value={publicacion.idListaVenta ? publicacion.idListaVenta : 0}
                  publicacion={publicacion}
                />
              </Borde>
            </div>
            <div className="col-sm-5 borde-formulario">
              <Borde titulo="Estado Publicaciones">
                <Estado onChange={handleChange} value={idPublicacionEstado} />
              </Borde>
            </div>
          </div>
          <div className="row">
            {publicacion.precioUnitario !== 0 && !publicacion.conPresupuesto && (
              <>
                <div className="col-sm-6 borde-formulario">
                  <Borde
                    titulo="Cambio de Precio"
                    ref={refPaso2}
                    error={errores.precioUnitario}
                  >
                    <CambioPrecio
                      idPublicacion={publicacion.idPublicacion}
                      onChangeState={handleChangeState}
                      value={publicacion.precioUnitario}
                      monedaSimbolo={publicacion.monedaSimbolo}
                      alicuota={publicacion.alicuota}
                      precioMayorista={publicacion.preciosMayorista}
                      isDisabled={false}
                    />
                  </Borde>
                </div>
                <div className="col-sm-5 borde-formulario">
                  <Borde titulo="Oferta">
                    <Ofertas
                      vieneDeAdministrar={true}
                      values={{
                        porcDcto: publicacion.porcDcto,
                        precioUnitario: publicacion.precioUnitario,
                        ofertaDesde: publicacion.ofertaDesde,
                        ofertaHasta: publicacion.ofertaHasta
                      }}
                      onChange={handleChange}
                    />
                  </Borde>
                </div>
              </>
            )}
          </div>
          <div className="row">
            <div className={`col-sm-${tieneMetadatos ? '6' : '11'} borde-formulario `}>
              <Borde
                titulo="Escribí la descripción de tu producto"
                error={errores.descripcion}
              >
                <DescripcionProducto
                  onChange={handleChange}
                  value={publicacion.descripcion}
                />
              </Borde>
              <Borde titulo="Fotografías">
                <AgregarFotos
                  value={publicacion.youtube || ''}
                  vieneDeAdministrar={true}
                  onChange={handleChange}
                  idPublicacion={publicacion.idPublicacion}
                  idPublicacionTemporal={0}
                />
              </Borde>
            </div>
            {tieneMetadatos && (
              <div className="col-sm-5 borde-formulario">
                <Borde titulo="">
                  <Metadatos idPublicacion={publicacion.idPublicacion} editable={true} />
                </Borde>
              </div>
            )}
          </div>
        </div>
        <div className="borde-formulario mb-3 ">
          <Borde titulo="Método de Pago y Envío">
            <VentasEspeciales
              vieneDeAdministrar={true}
              idPublicacion={publicacion.idPublicacion}
              values={{
                extensionGarantia: publicacion.extensionGarantia,
                garantias: publicacion.garantias,
                mediosPagos: publicacion.mediosPagos,
                mediosEnvios: publicacion.mediosEnvios,
                envioGratis: publicacion.envioGratis
              }}
              onChange={handleChange}
              errorMediosEnvios={errores.mediosEnvios}
              errorMediosPagos={errores.mediosPagos}
            />
          </Borde>
        </div>{' '}
        <div className="row">
          <div className="col">
            <div className="col d-flex justify-content-end">
              <LinkButton className="btn btn-volver-comprar w-50" onClick={validarForm}>
                {grabando ? (
                  <span>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="mr-2"
                    />
                    Guardando...
                  </span>
                ) : (
                  <span>
                    <i className="fa fa-check mr-2" aria-hidden="true" />
                    Aceptar
                  </span>
                )}
              </LinkButton>
            </div>
          </div>
          <div className="col">
            <LinkButton className="btn btn-reclamar w-50" onClick={cancelarForm}>
              <i className="fa fa-times mr-2" aria-hidden="true" />
              Cancelar
            </LinkButton>
          </div>
        </div>
      </form>
      <Modal show={showModal} onHide={handleClose} size={'lg'} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>
            <h3>Estado publicación</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{showModalMessage}</Modal.Body>
        <Modal.Footer>
          <button type="submit" className="btn btn-volver-comprar" onClick={validarForm}>
            Aceptar
          </button>
          <button type="button" className="btn btn-enviar" onClick={handleClose}>
            Cancelar
          </button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

DetalleCabecera.propTypes = {
  publicacion: PropTypes.shape({
    idPublicacionEstado: PropTypes.number.isRequired,
    cantDisponible: PropTypes.number.isRequired,
    idPublicacionExposicion: PropTypes.number.isRequired,
    idPublicacion: PropTypes.number.isRequired,
    titulo: PropTypes.string.isRequired,
    monedaSimbolo: PropTypes.string.isRequired,
    precioUnitario: PropTypes.number.isRequired,
    totalItemsPedidos: PropTypes.number.isRequired,
    publicacionEstado: PropTypes.string.isRequired,
    publicacionExposicion: PropTypes.string.isRequired,
    desde: PropTypes.string,
    hasta: PropTypes.string,
    etiquetas: PropTypes.string,
    idListaVenta: PropTypes.number,
    descripcion: PropTypes.string,
    youtube: PropTypes.string,
    extensionGarantia: PropTypes.number,
    garantias: PropTypes.array,
    mediosPagos: PropTypes.array,
    mediosEnvios: PropTypes.array,
    envioGratis: PropTypes.bool,
    porcDcto: PropTypes.number,
    ofertaDesde: PropTypes.string,
    ofertaHasta: PropTypes.string,
    alicuota: PropTypes.number
  }).isRequired,
  idPublicacion: PropTypes.number.isRequired,
  setPublicacion: PropTypes.func.isRequired,
  Validador: PropTypes.shape({
    validarDato: PropTypes.func.isRequired
  }).isRequired
}

export default withValidador(DetalleCabecera)
